export const DynamicFieldType = {
    Text: 'Text',
    TextArea: 'TextArea',
    NumberInteger: 'NumberInteger',
    NumberDecimal: 'NumberDecimal',
    Currency: 'Currency',
    Date: 'Date',
    Time: 'Time',
    DateTime: 'DateTime',
    Checkbox: 'Checkbox',
    Select: 'Select',
    Radio: 'Radio',
    Multiselect: 'Multiselect',
    Lookup: 'Lookup',
    Switch: 'Switch',
    GenericEntity: 'GenericEntity'
} as const;

export type DynamicFieldType = (typeof DynamicFieldType)[keyof typeof DynamicFieldType];

export interface DynamicField {
    id: string;
    code: string;
    type: DynamicFieldType;
    labels: Record<string, string>; // i18n

    order: number;
    required: boolean;
    readonly: boolean;
    disabled: boolean;
    visible: boolean;
    isUnique: boolean;

    regex?: string;
    mask?: string;
    minValue?: number;
    maxValue?: number;

    defaultText?: string;
    defaultNumeric?: number;
    defaultDate?: string; // ISO

    genericListId?: string;
    genericEntityId?: string;

    layouts?: DynamicFieldLayout[];
}

export interface DynamicFieldLayout {
    id?: string;
    dynamicFieldId?: string;
    colSpan: number;
    rowSpan: number;
    colStart: number;
    rowStart: number;
    breakpoint: string;
}
